import { render } from "./MerChantDealPriceList.vue?vue&type=template&id=8269dc5c&scoped=true"
import script from "./MerChantDealPriceList.vue?vue&type=script&lang=js"
export * from "./MerChantDealPriceList.vue?vue&type=script&lang=js"

import "./MerChantDealPriceList.vue?vue&type=style&index=0&id=8269dc5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8269dc5c"]])

export default __exports__